import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const DomainExclusionListView = React.lazy(
  () => import("./DomainExclusionList.view")
);

const DomainExclusionListLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <DomainExclusionListView />
  </React.Suspense>
);
export default () => <DomainExclusionListLoadable />;
